import React from "react";
import StripeCheckout from "react-stripe-checkout";
import "./styles.css";

const ErrorMessage = ({ text, showMessage }) => (
  <div
    class={showMessage ? "check-agreement-msg" : "check-agreement-msg-hidden"}
  >
    {text}
    {/* {text ? text : "Please check agreement."} */}
  </div>
);

const DownPaymentButton = ({
  // onStripeModalClose
  displayLoadingButton,
  onButtonClick,
  customerInfoFormIsReadyForSubmission,
  // isAgreementChecked,
  errorMessage,
  onTokenReceived,
  isDisabledSubmitButtonClicked,
  onDisabledSubmitButtonClick,
  downPayment,
  email
}) => {
  return (
    <div>
      {customerInfoFormIsReadyForSubmission ? (
        <StripeCheckout
          token={onTokenReceived}
          // billingAddress={true}
          // closed={() => alert('nas')}
          currency="USD"
          description="Down Payment"
          amount={Number(downPayment) * 100}
          email={email}
          image="logo_sm.png"
          allowRememberMe={false}
          stripeKey={
            process.env.NODE_ENV !== "production" ||
            (process.env.NODE_ENV === "production" &&
              process.env.USE_TEST_STRIPE)
              ? "pk_test_xCYTlEQsPVsywWyvJfT7MS1S"
              : "pk_live_rRBpRd7tzdFQpzEJoBHLOvqU"
          }
          // stripeKey={"pk_test_xCYTlEQsPVsywWyvJfT7MS1S"}
          // stripeKey={"pk_live_rRBpRd7tzdFQpzEJoBHLOvqU"}
        >
          {/* The onClick for this button seems to bubble up where the StripeCheckout parent handles it */}
          <button
            class="btn btn-primary btn-downpayment"
            type="submit"
            // onClick={onButtonClick}
            // onClick={e => {
            //   // Prevent click event from bubbling up to Stripe, activating the down payment window
            //   if (!customerInfoFormIsReadyForSubmission) {
            //     e.stopPropagation();
            //   }
            // }}
          >
            Make Down Payment
          </button>
        </StripeCheckout>
      ) : (
        <button
          class="btn btn-primary btn-downpayment disabled"
          onClick={
            displayLoadingButton ? undefined : onDisabledSubmitButtonClick
          }
        >
          {displayLoadingButton ? "Please wait..." : "Make Down Payment"}
        </button>
      )}
      <ErrorMessage
        {...{
          text: errorMessage,
          showMessage: !!errorMessage
        }}
      />
    </div>
  );
};

export default DownPaymentButton;



// WEBPACK FOOTER //
// ./src/scenes/ReviewOrder/CustomerInfoForm/components/DownPaymentButton/index.js